export const getFilteredWordSearches = (wordSearches, { status, text }) => {
    return wordSearches
        .filter((wordSearch) => text && text != '' ? wordSearch.name.toLowerCase().includes(text) : true)
        .filter((wordSearch) => (status ? wordSearch.status === status : true));
};
